
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/nodes",
      function () {
        return require("private-next-pages/archive/nodes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/nodes"])
      });
    }
  